import parseRenderingContext from '@utils/parse-rendering-context';
import CheckoutAppliedPromo from './checkout-applied-promo';
import CheckoutPromo from './checkout-promo';
import CheckoutSummary from './checkout-summary';
import template from './templates/checkout-summary-promos';
import { context as defaultContext } from './checkout-defaults';
import store from '@stores/cart/cart-store';

export default class CheckoutSummaryPromos extends CheckoutSummary.extendTemplate(template) {
    constructor($originEl, context) {
        context = { ...defaultContext, ...context };

        super($originEl, context);

        this.$promoCodeLabel = this.$el.find('[data-label="promoCode"]');

        this.$promo = this.$el.find('[data-region="promo"]');

        this.$appliedPromoPlaceholder = this.$el.find('[data-placeholder="appliedPromo"]');
        this.$promoPlaceholder = this.$el.find('[data-placeholder="promo"]');
        
        this.appliedPromo = null;
        this.promo = null;

        this.context = context;
    }

    init() {
        super.init();

        this.renderAppliedPromo();
        this.renderLabelOverrides();
        this.renderPromo();
        this.updatePromo();
    }

    async onCheckoutClick() {
        if(this.reactive.checkoutLoading) {
            return;
        }

        this.$error.slideUp('fast');
        this.reactive.checkoutLoading = true;

        const { success, error } = await store.actions.submitCart();
        if(!success) {
            this.$error.html(error).slideDown('fast');
        }

        this.reactive.checkoutLoading = false;
    }

    setupListeners() {
        super.setupListeners();

        this.$checkoutCtrl.on('click', () => this.onCheckoutClick());

        store.watch('promoCode', () => this.updatePromo());
    }

    hideLoading() {
        super.hideLoading();

        this.$checkoutCtrl.removeClass('disabled').attr('aria-disabled', null);
    }

    showLoading() {
        super.showLoading();

        this.$checkoutCtrl.addClass('disabled').attr('aria-disabled', true);
    }

    renderAppliedPromo() {
        const context = {
            applied: this.context.Applied,
            remove: this.context.RemovePromoSrText
        };

        this.appliedPromo = new CheckoutAppliedPromo(this.$appliedPromoPlaceholder, context, {
            replaceOriginEl: true,
            removeable: false
        });

        this.appliedPromo.render();
    }

    renderLabelOverrides() {
        this.$checkoutLabel.html(this.context.PlaceOrder);
    }

    renderPromo() {
        this.promo = new CheckoutPromo(this.$promoPlaceholder, this.context, {
            replaceOriginEl: true
        });

        this.promo.render();
    }

    renderTotals() {
        super.renderTotals();

        this.updateUpsell();
    }

    updatePromo() {
        if(store.state.promoCode) {
            this.$promo.show();
        } else {
            this.$promo.hide();
        }
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-checkout-summary-promos');
    rootEls.forEach((el) => {
        const $el = $(el);
        const renderingContext = parseRenderingContext(el);

        const summary = new CheckoutSummaryPromos($el, renderingContext);
        summary.init();

        summary.showLoading();
        const unwatch = store.watch('loaded', (...[, , loaded]) => {
            if (loaded) {
                unwatch();
            }
        });
    });
});
